import {
  Box,
  Container,
  Typography,
  Paper,
  Button,
  Grid,
} from '@mui/material';
import ParallaxHeader from '../components/ParallaxHeader';

const services = [
  {
    category: 'Hair Cuts',
    items: [
      { service: 'Adult Basic Cut', price: '$17.00' },
      { service: `Children's Basic Cut`, price: '$14.00' },
      { service: `Men's Bang & Beard Trim`, price: '$8.00' },
      { service: 'First Responder / Active Military Basic Cut', price: '$10.00*' },
    ],
  },
  {
    category: 'Styles',
    items: [
      { service: 'Shampoo & Blow-dry', price: '$15.00 & Up**' },
      { service: 'Shampoo & Roller Set', price: '$25.00 & Up**' },
    ],
  },
  {
    category: 'Color / Highlight / Lowlight',
    items: [
      { service: 'Color Re-Touch', price: '$60.00 & Up**' },
      { service: 'Full Color', price: '$70.00 & Up**' },
      { service: 'Highlights / Lowlights', price: '$25.00 & Up**' },
      { service: `Peek-a-boo's`, price: '$25.00 & Up**' },
      { service: `Men's Camo Color`, price: '$30.00' },
    ],
  },
  {
    category: 'Perms & Relaxers',
    items: [
      { service: 'Perms', price: '$55.00 & Up**' },
      { service: 'Relaxers', price: '$75.00 & Up**' },
    ],
  },
  {
    category: 'Specialty Treatments',
    items: [
      { service: 'Conditioning Treatments', price: '$15.00 & Up**' },
      { service: 'Malibu Treatments', price: '$25.00 & Up**' },
      { service: 'Waxing (Eyebrow & Facial)', price: '$10.00 & Up**' },
    ],
  },
];

const Prices = () => {
  return (
    <>
      <ParallaxHeader
        title="Services & Pricing"
        description="Professional services tailored to your needs"
        imageUrl="/images/content/pink-bubble-gum.jpg"
        height={300}
      />
      <Box sx={{ py: 8, backgroundColor: 'background.paper' }}>
        <Container maxWidth="lg">
          <Grid container spacing={8}>
            {services.slice(0, 2).map((category) => (
              <Grid item xs={12} md={6} key={category.category}>
                <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 700, mb: 3, fontSize: { xs: '1.5rem', md: '2rem' } }}>
                  {category.category}
                </Typography>
                <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }}>
                  {category.items.map((item) => (
                    <Box
                      component="li"
                      key={item.service}
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        py: 1.5,
                        borderBottom: '1px solid #eee',
                        fontSize: { xs: '0.85rem', md: '1.25rem' },
                      }}
                    >
                      <span>{item.service}</span>
                      <span style={{ fontWeight: 400 }}>{item.price}</span>
                    </Box>
                  ))}
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Parallax divider after Hair Cuts and Styles, full width */}
      <ParallaxHeader
        title=""
        description=""
        imageUrl="/images/content/hair-tools.jpg"
        height={300}
      />

      <Box sx={{ py: 8, backgroundColor: 'background.paper' }}>
        <Container maxWidth="lg">
          <Grid container spacing={8} sx={{ mt: 0 }}>
            {services.slice(2).map((category) => (
              <Grid item xs={12} md={6} key={category.category}>
                <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 700, mb: 3, fontSize: { xs: '1.5rem', md: '2rem' } }}>
                  {category.category}
                </Typography>
                <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }}>
                  {category.items.map((item) => (
                    <Box
                      component="li"
                      key={item.service}
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        py: 1.5,
                        borderBottom: '1px solid #eee',
                        fontSize: { xs: '0.85rem', md: '1.25rem' },
                      }}
                    >
                      <span>{item.service}</span>
                      <span style={{ fontWeight: 400 }}>{item.price}</span>
                    </Box>
                  ))}
                </Box>
              </Grid>
            ))}
          </Grid>

          <Box sx={{ textAlign: 'center', mt: 4 }}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1, fontSize: { xs: '0.8rem', md: '0.95rem' } }}>
              * Active Duty First Responders and Military Personnel Only
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '0.8rem', md: '0.95rem' } }}>
              ** Pricing depends on length of hair and estimated amount of product used.
            </Typography>
          </Box>

          <Box sx={{ textAlign: 'center', mt: 8, backgroundColor: 'grey.100', p: 6, borderRadius: 2 }}>
            <Typography variant="h4" gutterBottom sx={{ fontSize: { xs: '1.3rem', md: '1.7rem' } }}>
              Ready to Transform Your Look?
            </Typography>
            <Typography variant="body1" paragraph sx={{ maxWidth: 600, mx: 'auto', mb: 4, fontSize: { xs: '0.9rem', md: '1.05rem' } }}>
              Prices may vary based on hair length, thickness, and complexity of service.
              A consultation is recommended for new clients and complex services.
            </Typography>
            <Button
              variant="contained"
              color="secondary"
              size="large"
              href="https://app.salonrunner.com/customer/directory/index.htm?id=35742"
              target="_blank"
              sx={{
                py: 1.2,
                px: 3,
                fontSize: '0.9rem',
              }}
            >
              Book Your Appointment
            </Button>
            <Typography variant="body2" sx={{ mt: 3, color: 'text.secondary', fontSize: { xs: '0.8rem', md: '0.95rem' } }}>
              Questions? Call us at{' '}
              <a href="tel:813-591-6538" style={{ color: 'inherit' }}>
                (813) 591-6538
              </a>
            </Typography>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Prices;
